import React, { useState, useEffect } from "react";
import moment from "moment";
import { TaskTimeLabel } from "./TasksListComponent";

const MilestoneTooltipModal = ({ milestone, fetchStatus }) => {
  const [taskStatusCounts, setTaskStatusCounts] = useState({});
  const [milestoneEstTime, setMilestoneEstTime] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [totalLogged, setTotalLogged] = useState(0);
  const [taskCount, setTaskCount] = useState(0);
  const [groupStatusCounts, setGroupStatusCounts] = useState({});

  useEffect(() => {
    if (milestone) {
      const handleMouseOver = async (id) => {
        const statuses = fetchStatus;
        setStatuses(statuses);
        const statusMap = new Map(
          statuses.map((status) => [status._id, status.task_status])
        );

        const statusCounts = {};
        const groupCounts = {};

        milestone.tasks.forEach((task) => {
          const statusId = task?.task_status?._id;
          const statusName = statusMap.get(statusId) || "Unknown";
          if (!statusCounts[statusName]) {
            statusCounts[statusName] = 0;
          }
          statusCounts[statusName]++;
        });

        milestone.groups.forEach((group) => {
          group.tasks.forEach((task) => {
            const statusId = task?.task_status?._id;
            const statusName = statusMap.get(statusId) || "Unknown";
            if (!groupCounts[group._id]) {
              groupCounts[group._id] = {};
            }
            if (!groupCounts[group._id][statusName]) {
              groupCounts[group._id][statusName] = 0;
            }
            groupCounts[group._id][statusName]++;
          });
        });

        function timeStringToDecimal(timeString) {
          if (!timeString) return 0;
          const [hours, minutes] = timeString.split(":").map(Number);
          return hours * 60 + minutes;
        }

        function formatTime(time) {
          const totalHours = Math.floor(time / 60);
          const totalMinutes = time % 60;
          return `${totalHours}:${totalMinutes.toString().padStart(2, "0")}`;
        }

        let totalEstimateTime = 0;
        let totalTimeSpent = 0;

        // 🔹 Add times from milestone.tasks
        if (Array.isArray(milestone.tasks)) {
          milestone.tasks.forEach((task) => {
            totalEstimateTime += timeStringToDecimal(task.estimate);
            totalTimeSpent += timeStringToDecimal(task.task_logged_time);
          });
        }

        // 🔹 Add times from milestone.groups[].tasks
        if (Array.isArray(milestone.groups)) {
          milestone.groups.forEach((group) => {
            if (Array.isArray(group.tasks)) {
              group.tasks.forEach((task) => {
                totalEstimateTime += timeStringToDecimal(task.estimate);
                totalTimeSpent += timeStringToDecimal(task.task_logged_time);
              });
            }
          });
        }

        const formattedEstimateTime = formatTime(totalEstimateTime);
        const formattedLoggedTime = formatTime(totalTimeSpent);

        setTaskStatusCounts(statusCounts);
        setMilestoneEstTime(formattedEstimateTime);
        setTotalLogged(formattedLoggedTime);

        let totalTasks = 0;

        milestone.groups.forEach((group) => {
          totalTasks += group.tasks.length;
        });

        totalTasks += milestone.tasks.length;
        setTaskCount(totalTasks);
        setGroupStatusCounts(groupCounts);
      };
      handleMouseOver();
    }
  }, [milestone, fetchStatus]);

  const mergeStatusCounts = { ...taskStatusCounts };
  milestone.groups.forEach((group) => {
    Object.entries(groupStatusCounts[group._id] || {}).forEach(
      ([status, count]) => {
        if (mergeStatusCounts[status]) {
          mergeStatusCounts[status] += count;
        } else {
          mergeStatusCounts[status] = count;
        }
      }
    );
  });

  return (
    <div className="p-4 bg-theme-paper rounded-theme-lg">
      <ul className="flex flex-col gap-2 pb-2">
        <li>
          <h2 className="font-extrabold text-xl text-theme-fg-1">
            {milestone?.milestone?.title}
          </h2>
          <p className="text-[10px] text-theme-fg-3">
            {moment(milestone?.milestone?.createdAt).format(
              "DD-MM-YYYY hh:mm A"
            )}
          </p>
        </li>
        <li className="text-theme-fg-3 flex items-center">
          <p className="mr-2">Estimated time :</p>
          <TaskTimeLabel
            taskUsedTime={milestoneEstTime}
            taskEstimateTime={totalLogged}
          />
        </li>
        <li className="text-theme-fg-3">
          No. of Groups:{" "}
          <span className="ml-2 text-sm text-theme-fg-1">
            {milestone?.groups?.length}
          </span>
        </li>
        <li className="text-theme-fg-3">
          No. of Tasks:{" "}
          <span className="text-sm text-theme-fg-1 ml-2">{taskCount}</span>
        </li>
      </ul>
      <ul className="flex gap-6 mt-5">
        {Object.entries(mergeStatusCounts).map(([status, count]) => {
          const statusInfo = statuses.find((s) => s.task_status === status);
          const bgColor = statusInfo ? statusInfo.bg_color : "bg-theme-cream-2";
          const textColor = statusInfo
            ? statusInfo.text_color
            : "theme-fg-2";

          return (
            <li
              key={status}
              className={`${bgColor} text-${textColor} pt-1 pb-1 pl-2 pr-2 rounded-theme-pill`}
            >
              <p className="text-xs font-semibold">{count + " in " + status}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MilestoneTooltipModal;
